import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import SocketPlugin from "@/plugins/SocketPlugin";
import ReloadRoutePlugin from "@/plugins/ReloadRoutePlugin";
import {plugin} from "@/niftybit";
import axios from "axios";
import localization from "@/localization";
import initializer from "@/initializer";

axios.defaults.baseURL = "https://" + location.host + "/api/frontend";
axios.defaults.headers.common['Accept'] = "application/json";
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let app = createApp(App);

app.use(SocketPlugin);
app.use(ReloadRoutePlugin);

app.use(plugin);

app.mixin({
    methods: {
        translate(key) {
            return localization.translate(key);
        }
    },
});

app.config.unwrapInjectedRef = true; // #TODO remove when updating to vue 3.3

app.use(router).mount('#app');

initializer.initialize();
